"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = exports.Header = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const icon_button_1 = __importDefault(require("../icon-button"));
const PREFIX = "ContainerDialog";
exports.classes = {
    "bg-white": `${PREFIX}-bg-white`,
    "bg-pearl": `${PREFIX}-bg-pearl`,
    "bg-alabaster": `${PREFIX}-bg-alabaster`,
    "width-sm": `${PREFIX}-width-sm`,
    "width-md": `${PREFIX}-width-md`,
    "width-lg": `${PREFIX}-width-lg`,
    "width-xl": `${PREFIX}-width-xl`,
    allowOverflow: `${PREFIX}-allowOverflow`,
    content: `${PREFIX}-content`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: "3px",
    outline: "none",
    width: "calc(100% - 32px)",
    maxHeight: "calc(100% - 20px)",
    display: "flex",
    flexFlow: "column nowrap",
    [theme.breakpoints.up("md")]: {
        width: "calc(100% - 48px)"
    },
    [theme.breakpoints.down("sm")]: {
        maxHeight: "100%",
        boxShadow: "none",
        borderRadius: 0,
        height: "100%",
        width: "100%"
    },
    [theme.breakpoints.up("xl")]: {
        height: "100%"
    },
    [`&.${exports.classes["bg-white"]}`]: {
        backgroundColor: theme.colours.white
    },
    [`&.${exports.classes["bg-pearl"]}`]: {
        backgroundColor: theme.colours.pearl
    },
    [`&.${exports.classes["bg-alabaster"]}`]: {
        backgroundColor: theme.colours.alabaster
    },
    [`&.${exports.classes["width-sm"]}`]: {
        maxWidth: theme.breakpoints.values.sm
    },
    [`&.${exports.classes["width-md"]}`]: {
        maxWidth: theme.breakpoints.values.md
    },
    [`&.${exports.classes["width-lg"]}`]: {
        maxWidth: theme.breakpoints.values.lg
    },
    [`&.${exports.classes["width-xl"]}`]: {
        maxWidth: theme.breakpoints.values.xl
    },
    [`&.${exports.classes.allowOverflow}`]: {
        [`& .${exports.classes.content}`]: {
            overflow: "auto"
        }
    },
    [`& .${exports.classes.content}`]: {
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        paddingTop: "0px",
        margin: "0px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("sm")]: {
            height: "100%"
        },
        [theme.breakpoints.up("xl")]: {
            height: "100%"
        }
    }
}));
exports.Header = (0, styles_1.styled)("div")({
    display: "flex",
    flex: "0 0 auto",
    flexFlow: "row nowrap",
    justifyContent: "flex-end"
});
exports.StyledIconButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    color: theme.colours.charcoal,
    margin: "6px 6px 16px 16px"
}));
//# sourceMappingURL=data:application/json;base64,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